import React from "react";
import { useNavigate } from "react-router";
const FeedBack = () => {
    const navigate=useNavigate();
    const submissionData = [
        {
            studentName: "John Doe",
            subjectName: "English",
            topicName: "Essay Writing",
            section:"Planning And Prep",
            Type:"Feedback 1",
            requestDate: "Jan 08, 2025",
        },
        {
            studentName: "John Doe",
            subjectName: "English",
            topicName: "Essay Writing",
            section:"Planning And Prep",
            Type:"Feedback 1",
            requestDate: "Jan 08, 2025",
        }, {
            studentName: "John Doe",
            subjectName: "English",
            topicName: "Essay Writing",
            section:"Planning And Prep",
            Type:"Feedback 1",
            requestDate: "Jan 08, 2025",
        }, {
            studentName: "John Doe",
            subjectName: "English",
            topicName: "Essay Writing",
            section:"Planning And Prep",
            Type:"Feedback 1",
            requestDate: "Jan 08, 2025",
        },
    ];
    return (
        <div className="">
            <div className=" w-full flex flex-col p-8">
                <div className="bg-white border-gray-400 rounded-lg border-2 w-full mt-8 relative p-4 ">
                    <p className="absolute bg-white text-2xl font-medium -top-8 left-8 p-2">
                        Feedback Requests
                    </p>
                    <div className="overflow-x-auto">
                        <table className="w-full ">
                            <thead className="text-[16px] font-medium">
                                <tr>
                                    <th className="px-4 py-3 text-left text-gray-700 font-semibold">
                                        Student Name
                                    </th>
                                    <th className="px-4 py-3 text-left text-gray-700 font-semibold">
                                        Subject Name
                                    </th>
                                    <th className="px-4 py-3 text-left text-gray-700 font-semibold">
                                        Topic Name
                                    </th>
                                    <th className="px-4 py-3 text-left text-gray-700 font-semibold">
                                       Section
                                    </th>
                                    <th className="px-4 py-3 text-left text-gray-700 font-semibold">
                                      Type
                                    </th>
                                    <th className="px-4 py-3 text-left text-gray-700 font-semibold">
                                        Request Date
                                    </th>
                                    <th className="px-4 py-3 text-center text-gray-700 font-semibold">
                                        Options
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-400">
                                {submissionData.map((submission, index) => (
                                    <tr key={index} className="hover:bg-gray-50">
                                        <td className="px-4 py-3 whitespace-nowrap">
                                            {submission.studentName}
                                        </td>
                                        <td className="px-4 py-3 whitespace-nowrap">
                                            {submission.subjectName}
                                        </td>
                                        <td className="px-4 py-3 whitespace-nowrap">
                                            {submission.topicName}
                                        </td>
                                        <td className="px-4 py-3 whitespace-nowrap">
                                            {submission.section}
                                        </td>
                                        <td className="px-4 py-3 whitespace-nowrap">
                                            {submission.Type}
                                        </td>
                                        <td className="px-4 py-3 whitespace-nowrap">
                                            {submission.requestDate}
                                        </td>
                                        <td className="py-3 -px-5 whitespace-nowrap  flex justify-center items-center">
                                            <button onClick={()=>navigate("/supervisor/give-feedback")} className="flex items-center justify-center gap-1 bg-blue-600 text-white px-3 py-1 rounded-lg text-sm">
                                               
                                                Give Feedback
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FeedBack;
